module.exports = __webpack_public_path__ + "fonts/MicrogrammaD-BoldExte.57690b0.woff2";